import { Fusion } from './types';

export interface MappedMyCompanyFusions {
  isMriSimmonsActivated: boolean;
}

export const TARGET_FUSION = 'mri_simmons';

export const mapMyCompanyFusions = (
  response: Array<Fusion>
): MappedMyCompanyFusions => {
  const mriSimmonsData = response?.find(item => item.slug === TARGET_FUSION);
  const isMriSimmonsActivated =
    mriSimmonsData?.options?.find(item => item.fusion_option_id === 1)
      ?.enabled ?? false;

  return {
    isMriSimmonsActivated,
  };
};
